'use strict';
import angular from 'angular';
import accountabilityGroupLabelHtmlUrl from './views/accountabilityGroupLabel.list.html';

var app = angular.module('app.accountabilityGroupLabel.component', []);
app.component('accountabilityGroupLabel', {
  bindings: {
    showActions: '<',
    selectedAccountabilityGroupLabel: '=',
    clusterId: '=',
    isFormEdit: '=',
    clientId: '='
  },
  templateUrl: accountabilityGroupLabelHtmlUrl,
  controller: function ($stateParams, FormService, $ioAlert) {
    var self = this;

    self.groupLabelsList = [];
    self.filteredList = [];
    self.selectedText = '';
    self.searchTerm = '';
    self.dropdownVisible = false;
    self.selectionStatus = 'existing';

    self.toggleLabelsList = function () {
      if (!self.showActions) return;
      self.dropdownVisible = !self.dropdownVisible;
    };

    self.getAccountabilityGroupLabels = function () {
      const orderId = $stateParams.orderId;
      FormService.getExistingAccountabilityGroupLabels(orderId).then(function (success) {
        if (success && success.data && success.data.length > 0) {
          self.groupLabelsList = success.data.map(label => ({
            id: label.id,
            name: label.group_label
          }));
          self.filteredList = self.groupLabelsList;

          if (Array.isArray(self.selectedAccountabilityGroupLabel) && self.selectedAccountabilityGroupLabel.length > 0) {
            const existingId = self.selectedAccountabilityGroupLabel[0].id;
            const match = _.find(self.groupLabelsList, { id: existingId });
            if (match) {
              self.selectedText = match.name;
              self.selectionStatus = 'existing';
            }
          }
        }
      }, function (error) {
        $ioAlert.show('Error!', 'Failed to fetch Accountability Group Labels '+ error, 'error');
      });
    };

    self.onSearchChange = function () {
      const term = (self.searchTerm || '').toLowerCase();
      self.filteredList = self.groupLabelsList.filter(label =>
        label.name.toLowerCase().includes(term)
      );
    };

    self.selectLabel = function (label) {
      self.selectedText = label.name;
      self.searchTerm = label.name;
      self.selectionStatus = 'existing';
      self.selectedAccountabilityGroupLabel = [{
        id: label.id,
        name: label.name,
        status: 'existing'
      }];
      self.dropdownVisible = false;
    };

    self.finalizeLabelSelection = function () {
      const trimmed = (self.searchTerm || '').trim();
      if (!trimmed) return;

      const match = self.groupLabelsList.find(p => p.name.toLowerCase() === trimmed.toLowerCase());

      if (match) {
        self.selectLabel(match);
      } else {
        self.selectedAccountabilityGroupLabel = [{
          id: null,
          name: trimmed,
          status: 'new'
        }];
        self.selectedText = trimmed;
        self.selectionStatus = 'new';
      }

      self.dropdownVisible = false;
    };

    self.handleKeyDown = function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        self.finalizeLabelSelection();
      }
    };

    self.initComponent = function () {
      if (self.selectedAccountabilityGroupLabel && !_.isEmpty(self.selectedAccountabilityGroupLabel)) {
        self.selectedAccountabilityGroupLabel = JSON.parse(self.selectedAccountabilityGroupLabel);
        self.searchTerm = self.selectedAccountabilityGroupLabel[0].name;
        self.selectedText = self.searchTerm;
        self.selectionStatus = self.selectedAccountabilityGroupLabel[0].status || 'existing';
      } else {
        self.selectedAccountabilityGroupLabel = '';
        self.searchTerm = '';
        self.selectionStatus = 'existing';
      }
      self.getAccountabilityGroupLabels();
    };

    self.initComponent();
  }
});
